"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CalendarDateUtility_1 = __importDefault(require("./CalendarDateUtility"));
class ViewModelHelper {
    static getViewModels(calSrcModel, viewModelFactory) {
        if (calSrcModel === undefined || calSrcModel.weeks.length === 0) {
            return {
                days: [],
                slots: [],
                weeks: [],
                months: [],
                weekDayNames: []
            };
        }
        return this._createViewModels(calSrcModel, viewModelFactory);
    }
    static _createViewModels(calSrcModel, viewModelFactory) {
        let dayVModels = [];
        let slotVModels = [];
        let weekVModels = [];
        let calWeekIndex = 0;
        let calSlotsIndex = 0;
        let calDaysIndex = 0;
        const dayVModelsByMonthMap = {};
        for (let weekIndex = 0, len = calSrcModel.weeks.length; weekIndex < len; weekIndex++) {
            const weekModel = calSrcModel.weeks[weekIndex];
            const weekStartMonth = CalendarDateUtility_1.default.getDateInfoString(weekModel.days[0].date).month;
            const weekEndMonth = CalendarDateUtility_1.default.getDateInfoString(weekModel.days[6].date).month;
            let dayVModelsByWeek = [];
            for (let weekDayIndex = 0, weekDayLen = weekModel.days.length; weekDayIndex < weekDayLen; weekDayIndex++) {
                const dayModel = weekModel.days[weekDayIndex];
                const dateInfo = CalendarDateUtility_1.default.getDateInfoString(dayModel.date);
                let slotStartIndex;
                let slotEndIndex;
                const numOfSlots = dayModel.slots.length;
                if (numOfSlots > 0) {
                    slotStartIndex = calSlotsIndex;
                    slotEndIndex = slotStartIndex + numOfSlots - 1;
                    calSlotsIndex = slotEndIndex + 1;
                }
                slotVModels = slotVModels.concat(this._getSlotViewModelsOfDay(dayModel, calDaysIndex, slotStartIndex, viewModelFactory));
                const dayVModel = viewModelFactory.createModel('day', {
                    slots: dayModel.slots,
                    dateId: dayModel.id,
                    dayIndex: calDaysIndex,
                    weekIndex: calWeekIndex,
                    monthOfYear: dateInfo.month,
                    dayOfMonth: dateInfo.day,
                    slotsStartIndex: slotStartIndex,
                    slotsEndIndex: slotEndIndex
                });
                dayVModelsByWeek.push(dayVModel);
                dayVModels.push(dayVModel);
                calDaysIndex++;
            }
            const weekVModel = viewModelFactory.createModel('week', {
                weekIndex: calWeekIndex,
                weekStartMonth: weekStartMonth,
                weekEndMonth: weekEndMonth,
                days: dayVModelsByWeek
            });
            weekVModels.push(weekVModel);
            dayVModelsByMonthMap[weekStartMonth] = dayVModelsByMonthMap[weekStartMonth] || [];
            dayVModelsByMonthMap[weekEndMonth] = dayVModelsByMonthMap[weekEndMonth] || [];
            if (weekStartMonth === weekEndMonth) {
                dayVModelsByMonthMap[weekStartMonth].push(weekVModel);
            }
            else {
                dayVModelsByMonthMap[weekStartMonth].push(weekVModel);
                dayVModelsByMonthMap[weekEndMonth].push(weekVModel);
            }
            calWeekIndex++;
        }
        return {
            days: dayVModels,
            slots: slotVModels,
            weeks: weekVModels,
            months: this._getMonthViewModels(dayVModelsByMonthMap, viewModelFactory),
            weekDayNames: this._getWeekDayNameViewModel(viewModelFactory)
        };
    }
    static _getWeekDayNameViewModel(viewModelFactory) {
        let weekDayNameVModels = [];
        const numOfDayInWeek = 7;
        for (let dayOfWeek = 0; dayOfWeek < numOfDayInWeek; dayOfWeek++) {
            weekDayNameVModels.push(viewModelFactory.createModel('weekDayName', {
                'dayOfWeek': dayOfWeek
            }));
        }
        return weekDayNameVModels;
    }
    static _getMonthViewModels(dayVModelsByMonthMap, viewModelFactory) {
        let monthVModels = [];
        for (let monthIndex in dayVModelsByMonthMap) {
            if (dayVModelsByMonthMap.hasOwnProperty(monthIndex)) {
                let dayVModelsByMonth = dayVModelsByMonthMap[monthIndex];
                // create month view model for complete month(month has 4 or 5 weeks)
                if (dayVModelsByMonth.length >= 4) {
                    monthVModels.push(viewModelFactory.createModel('month', {
                        monthOfYear: dayVModelsByMonth[0].weekEndMonth,
                        monthIndex: monthIndex,
                        weeks: dayVModelsByMonth
                    }));
                }
            }
        }
        return monthVModels;
    }
    static _getSlotViewModelsOfDay(dayModel, dayIndex, slotsStartIndex, viewModelFactory) {
        let slotVModels = [];
        let slotIndex = slotsStartIndex;
        const slotModels = dayModel.slots;
        for (let index in slotModels) {
            if (slotModels.hasOwnProperty(index)) {
                let slotVModel = viewModelFactory.createModel('slot', {
                    slotSource: slotModels[index],
                    slotIndex: slotIndex,
                    dateId: dayModel.id,
                    dayIndex: dayIndex
                });
                slotVModels.push(slotVModel);
                slotIndex++;
            }
        }
        return slotVModels;
    }
}
exports.default = ViewModelHelper;
